<template>
  <TemplateLogin
    v-slot="{ validate }"
    class="expired-reset-password-link"
    :error="errorMessage"
    :success="successMessage"
  >
    <i class="bi bi-exclamation-triangle-fill" />
    <h1 class="heading--medium">
      Password Reset Link Expired
    </h1>
    <p class="body--medium">
      Your password reset link expired. Click the button below to send a new link.
    </p>
    <button
      class="button-primary"
      :disabled="loading"
      @click="resendVerificationLink(validate)"
    >
      Send New Link
    </button>
  </TemplateLogin>
</template>

<script lang="js">
import TemplateLogin from '@/components/template/login/index.vue'
import { flashMessage } from '@/utils/flashMessage'
import services from "@/services";

export default {
    name: 'ExpiredResetPasswordLink',
    components: {
        TemplateLogin,
    },
    data() {
        return {
            errorMessage: "",
            successMessage: "",
            loading: false,
            flashMessage,
            email: "",
        }
    },
    mounted() {
        this.email = localStorage.getItem("last_reset_email") || "";
    },
    methods: {
        async resendVerificationLink(validate) {
            try {
                this.errorMessage = ""
                const result = await validate();
                if (!result.valid) return;

                this.loading = true
                const response = await services.auth.forgotPassword(this.email)
                flashMessage.set(response.message)
                this.$router.push('/login')
            } catch (error) {
                this.errorMessage = error.message
            }
            finally {
                this.loading = false
            }
        },
    }
}
</script>

<style lang="scss">
.expired-reset-password-link {
    text-align: center;

    .bi-exclamation-triangle-fill {
        font-size: $icon-large;
        color: #FF5C00;
    }

    p {
        margin: 0;
    }
}
</style>